export const teamMembers = [
  {
    slug: "valentine-bonamis",
    name: "Valentine Bonamis",
    role: "Avocate",
    barreau: "Barreau de Bruxelles",
    languages: "FR · EN · NL",
    authorId: 164,
    bio: "Avocate au Barreau de Bruxelles, elle conseille entreprises et organisations — SRL comme ASBL — sur leurs contrats, leur gouvernance et leurs questions de ressources humaines. Ses nombreuses publications dans la base de connaissances du cabinet reflètent une approche pédagogique : rendre le droit lisible pour ceux qui entreprennent.",
    image:
      "/images/team/valentine.jpg",
  },
  {
    slug: "quentin-de-bournonville",
    name: "Quentin de Bournonville",
    role: "Avocat",
    barreau: "Barreau de Bruxelles",
    languages: "FR · EN · NL",
    authorId: 167,
    aliasIds: [169],
    bio: "Avocat au Barreau de Bruxelles, il accompagne entrepreneurs, dirigeants et actionnaires dans la constitution et le financement de leurs sociétés — levées de fonds, structuration du capital, gouvernance — comme dans la prévention et la résolution de leurs litiges, commerciaux ou entre associés. Un même fil conducteur : structurer le capital, sécuriser les décisions, défendre les intérêts.",
    image:
      "/images/team/quentin.jpg",
  },
  {
    slug: "ruth-lodoiska",
    name: "Ruth Lodoiska",
    role: "Assistante non-juridique",
    barreau: "Cabinet e².law, Bruxelles",
    languages: "FR · EN · NL",
    authorId: 156,
    bio: "Premier point de contact du cabinet, elle coordonne l'accueil des clients, l'organisation des dossiers et la vie éditoriale de la base de connaissances.",
    image:
      "/images/team/ruth.jpg",
  },
];
